/**
 * @public
 */
export const ICONS = [
  "dp-custom-agent" as const,
  "dp-custom-check-circle" as const,
  "dp-custom-deskpro" as const,
  "dp-custom-exclamation-circle" as const,
  "dp-custom-information-circle" as const,
  "dp-custom-read" as const,
  "dp-custom-robot" as const,
  "dp-custom-sent" as const,
  "dp-custom-xmark" as const,
  "dazzle-linear-arrow-down" as const,
  "dazzle-linear-arrow-left" as const,
  "dazzle-linear-arrow-right" as const,
  "dazzle-linear-calendar" as const,
  "dazzle-linear-compress-alt" as const,
  "dazzle-linear-dots-horizontal" as const,
  "dazzle-linear-exclamation-mark" as const,
  "dazzle-linear-expand-alt" as const,
  "dazzle-linear-house-floor" as const,
  "dazzle-linear-message-circle-chat" as const,
  "dazzle-linear-search-alt" as const,
  "dazzle-linear-xmark" as const,
  "dazzle-solid-arrow-left" as const,
  "dazzle-solid-bell" as const,
  "dazzle-solid-book-open" as const,
  "dazzle-solid-bookmark" as const,
  "dazzle-solid-download" as const,
  "dazzle-solid-file" as const,
  "dazzle-solid-flag" as const,
  "dazzle-solid-guide" as const,
  "dazzle-solid-house-floor" as const,
  "dazzle-solid-mail-open-alt" as const,
  "dazzle-solid-mail" as const,
  "dazzle-solid-message-circle-chat" as const,
  "dazzle-solid-message-circle-dots" as const,
  "dazzle-solid-message-square-chat" as const,
  "dazzle-solid-pause" as const,
  "dazzle-solid-pen-nib" as const,
  "dazzle-solid-play" as const,
  "dazzle-solid-search-alt" as const,
  "dazzle-solid-send-alt-1" as const,
  "dazzle-solid-upload" as const,
  "dazzle-solid-user" as const,
  "dazzle-solid-volume-max" as const,
  "dazzle-solid-volume-xmark" as const,
  "heroicons-linear-newspaper" as const,
  "heroicons-solid-newspaper" as const,
  "tailwind-ui-outline-chevron-down" as const,
  "tailwind-ui-outline-chevron-right" as const,
  "tailwind-ui-outline-emoji-happy" as const,
  "tailwind-ui-outline-external-link" as const,
  "tailwind-ui-outline-paper-clip" as const,
  "tailwind-ui-solid-information-circle" as const,
  "tailwind-ui-solid-newspaper" as const,
];

/**
 * @public
 */
export type IconType = (typeof ICONS)[number];
